import React from "react";
import Img from "gatsby-image";
import classnames from "classnames";
import AppSnippet from "../../lib/AppSnippet";
import cssClass from "./listStyles.module.scss";

const SpokenLanguageList = ({ spokenLanguagesArray }) => {
  return (
    <div className={cssClass.container}>
      <p className="boldText">
        <AppSnippet snippet="spokenLanguagesTitle" />
      </p>
      <ul className={classnames(cssClass.languagesList, cssClass.list)}>
        {spokenLanguagesArray.map(({ id, image, name }) => (
          <li key={id || name} className={cssClass.languageItem}>
            {image && (
              <Img className={cssClass.flagImage} fluid={image.fluid} />
            )}
            <span>{name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SpokenLanguageList;
